// assets/cicatribem-cart.js
// Controlador do carrinho lateral (minicart): abre/fecha, aplica o HTML novo da seção 'minicart', atualiza
// contadores e trata quantidade/remoção/cupom dentro do drawer.
//
// 01/11/2026 (revisão de código, A3-3 / A3-8): antes a rotina "aplicar HTML da seção + contador + abrir" existia em
// 5 cópias (minicart.liquid x2, global.js, shopable-video, buy-buttons/kit_section) e o abre/fecha em outras 5, todas
// com ramos mortos para um <cart-notification> que nenhum script define. Agora tudo passa por window.cbMinicart:
//   cbMinicart.abrir() / fechar() / estaAberto()
//   cbMinicart.aplicarHtml(htmlDaSecaoMinicart)      → troca #minicart-form e a barra de frete grátis
//   cbMinicart.atualizarContadores(cart)              → .cart-count (cabeçalho e drawer), subtotal, barra de frete
//   cbMinicart.atualizar(html, cart?)                 → os dois acima; busca /cart.js se cart não vier
//   cbMinicart.recarregar()                           → re-renderiza a seção com o carrinho atual
//   cbMinicart.adicionar(items, { abrir: true })      → POST /cart/add.js com a seção, atualiza e abre
// window.cicatribemMinicart continua existindo (o brinde-kit.js chama recarregar() por ele).

(function () {
  'use strict';

  function raiz() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function wrapper() {
    return document.getElementById('minicart_wrapper');
  }
  function interno() {
    return document.querySelector('#minicart_wrapper .minicart__wrapper');
  }

  var cbMinicart = {
    estaAberto: function () {
      return document.documentElement.classList.contains('open-minicart');
    },
    abrir: function () {
      var w = interno();
      if (!w) return false;
      w.classList.add('open');
      var wrap = wrapper();
      if (wrap) wrap.classList.add('open');
      document.documentElement.classList.add('open-drawer', 'open-minicart');
      return true;
    },
    fechar: function () {
      var w = interno();
      if (w) w.classList.remove('open');
      var wrap = wrapper();
      if (wrap) wrap.classList.remove('open');
      document.documentElement.classList.remove('open-drawer', 'open-minicart');
    },
    aplicarHtml: function (html) {
      if (!html) return false;
      var p = new DOMParser().parseFromString(html, 'text/html');
      var novo = p.getElementById('minicart-form');
      var atual = document.getElementById('minicart-form');
      if (novo && atual) atual.innerHTML = novo.innerHTML;
      var barraNova = p.querySelector('free-ship-progress-bar');
      var barraAtual = document.querySelector('#minicart_wrapper free-ship-progress-bar');
      if (barraNova && barraAtual) barraAtual.outerHTML = barraNova.outerHTML;
      else if (!barraNova && barraAtual) barraAtual.remove();
      return !!(novo && atual);
    },
    atualizarContadores: function (cart) {
      if (!cart) return;
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = el.classList.contains('cart-count-drawer')
          ? '(' + cart.item_count + ')'
          : cart.item_count > 100
            ? '~'
            : String(cart.item_count);
      });
      document.querySelectorAll('[data-cart-subtotal-price]').forEach(function (el) {
        el.textContent = (cart.total_price / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      });
      var barra = document.querySelector('free-ship-progress-bar');
      if (barra && typeof barra.init === 'function') barra.init(cart.items_subtotal_price);
    },
    lerCarrinho: function () {
      return fetch(raiz() + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    },
    atualizar: function (html, cart) {
      var self = this;
      if (html) self.aplicarHtml(html);
      return (cart ? Promise.resolve(cart) : self.lerCarrinho()).then(function (c) {
        self.atualizarContadores(c);
        document.dispatchEvent(new CustomEvent('cb:minicart:atualizado', { detail: c }));
        return c;
      });
    },
    recarregar: function () {
      var self = this;
      return Promise.all([
        fetch(window.location.pathname + '?sections=minicart', { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
        self.lerCarrinho()
      ]).then(function (res) {
        return self.atualizar(res[0] && res[0].minicart, res[1]);
      }).catch(function () {});
    },
    adicionar: function (items, opts) {
      var self = this;
      opts = opts || {};
      return fetch(raiz() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: ['minicart'], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (out) {
          if (!out.ok) {
            out.erro = (out.data && (out.data.description || out.data.message)) || 'Não foi possível adicionar ao carrinho.';
            out.erro = String(out.erro).replace(/<[^>]+>/g, '');
            return out;
          }
          var html = out.data && out.data.sections && out.data.sections.minicart;
          return self.atualizar(html).then(function (cart) {
            out.cart = cart;
            if (opts.abrir !== false) setTimeout(function () { self.abrir(); }, 120);
            return out;
          });
        });
    }
  };
  window.cbMinicart = cbMinicart;

  /* Abrir/fechar: ícone do cabeçalho, overlay, botões de fechar, Escape e clique fora. */
  document.addEventListener('click', function (e) {
    var alvo = e.target;
    if (!alvo || !alvo.closest) return;
    if (alvo.closest('a#cart-icon-bubble.minicart__action')) {
      e.preventDefault();
      cbMinicart.abrir();
      return;
    }
    if (alvo.classList && alvo.classList.contains('overlayminicart')) {
      cbMinicart.fechar();
      return;
    }
    if (alvo.closest('button.minicart-action.close-cart, .minicart-action.close-cart, .close-cart-button')) {
      e.preventDefault();
      cbMinicart.fechar();
      return;
    }
    if (cbMinicart.estaAberto() && !alvo.closest('#minicart_wrapper') && !alvo.closest('a#cart-icon-bubble, .minicart__action, [href$="/cart"]')) {
      cbMinicart.fechar();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cbMinicart.estaAberto()) cbMinicart.fechar();
  });

  /* Dentro do drawer: quantidade, remoção, formulários /cart/change e cupom. */
  function CicatribemMinicartController() {
    var self = this;
    this.isUpdating = false;
    window.cicatribemMinicart = this;
    document.addEventListener('DOMContentLoaded', function () { self.init(); });
    if (document.readyState !== 'loading') this.init();
  }

  CicatribemMinicartController.prototype.init = function () {
    if (this.cartDrawer) return;
    this.cartDrawer = wrapper();
    if (!this.cartDrawer) return;
    this.reopenCartOnLoad();
    this.initListeners();
    var self = this;
    document.addEventListener('cartUpdated', function () { self.recarregar(); });
  };

  CicatribemMinicartController.prototype.setLoading = function (btn) {
    if (this.isUpdating) return false;
    this.isUpdating = true;
    if (btn) {
      btn.disabled = true;
      btn.style.opacity = '0.7';
    }
    this.cartDrawer.classList.add('is-updating');
    return true;
  };

  CicatribemMinicartController.prototype.reopenCartOnLoad = function () {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('open_cart')) return;
    setTimeout(function () { cbMinicart.abrir(); }, 200);
    window.history.replaceState({}, document.title, window.location.pathname);
  };

  function linhaDe(el) {
    var item = el.closest('.cart-item');
    if (!item || !item.parentElement) return null;
    var todos = item.parentElement.querySelectorAll('.cart-item');
    return Array.prototype.indexOf.call(todos, item) + 1;
  }

  CicatribemMinicartController.prototype.initListeners = function () {
    var self = this;
    this.cartDrawer.addEventListener('click', function (event) {
      var btnQtd = event.target.closest('.quantity__button');
      if (btnQtd) {
        event.preventDefault();
        var input = btnQtd.parentElement.querySelector('.quantity-input');
        var linha = linhaDe(btnQtd);
        if (!linha || !input) return;
        var atual = parseInt(input.value, 10) || 0;
        var nova = btnQtd.name === 'plus' ? atual + 1 : atual - 1;
        if (nova >= 0 && self.setLoading(btnQtd)) self.updateItemQuantity(linha, nova);
        return;
      }
      var remover = event.target.closest('cart-remove-button, a[href*="/cart/change"]');
      if (remover) {
        event.preventDefault();
        var linha2 = linhaDe(remover);
        var qtd = 0;
        var link = remover.matches('a') ? remover : remover.querySelector('a[href*="/cart/change"]');
        if (link) {
          try {
            var u = new URL(link.getAttribute('href'), window.location.origin);
            if (u.searchParams.get('line')) linha2 = parseInt(u.searchParams.get('line'), 10);
            if (u.searchParams.get('quantity')) qtd = parseInt(u.searchParams.get('quantity'), 10) || 0;
          } catch (e) {}
        }
        if (!linha2) return;
        if (self.setLoading(remover)) self.updateItemQuantity(linha2, qtd);
      }
    });

    this.cartDrawer.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      var cupom = form.closest('.coupon-form');
      if (cupom) {
        self.handleCouponSubmit(event, cupom);
        return;
      }
      if (form.action && form.action.indexOf('/cart/change') !== -1) {
        event.preventDefault();
        var linha = 1;
        var inLinha = form.querySelector('[name="line"]');
        if (inLinha) linha = parseInt(inLinha.value, 10) || 1;
        else {
          var m = form.action.match(/[?&]line=([^&]+)/);
          if (m) linha = parseInt(m[1], 10) || 1;
        }
        var inQtd = form.querySelector('[name="quantity"]');
        var qtd = inQtd ? parseInt(inQtd.value, 10) : 0;
        if (isNaN(qtd)) qtd = 0;
        if (self.setLoading(form.querySelector('button'))) self.updateItemQuantity(linha, qtd);
      }
    });
  };

  CicatribemMinicartController.prototype.handleCouponSubmit = function (event, form) {
    var self = this;
    event.preventDefault();
    var input = form.querySelector('input[name="discount"]');
    var btn = form.querySelector('button');
    var feedback = form.parentElement.querySelector('.coupon-feedback');
    var code = (input && input.value || '').trim();
    if (!code || !this.setLoading(btn)) return;
    var textoOriginal = btn.textContent;
    btn.textContent = 'Aplicando...';
    if (feedback) { feedback.style.display = 'none'; feedback.textContent = ''; }
    function mostra(msg, cor) {
      if (!feedback) return;
      feedback.style.display = 'block';
      feedback.style.color = cor;
      feedback.textContent = msg;
    }
    function libera() {
      btn.textContent = textoOriginal;
      btn.disabled = false;
      btn.style.opacity = '';
      self.isUpdating = false;
      self.cartDrawer.classList.remove('is-updating');
    }
    // 1) aplica o cupom (cookie no domínio da Shopify); 2) relê o carrinho para conferir se entrou
    fetch(raiz() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function () { return cbMinicart.lerCarrinho(); })
      .then(function (cart) {
        libera();
        var aplicado =
          (cart.cart_level_discount_applications || []).some(function (d) { return (d.title || '').toLowerCase() === code.toLowerCase(); }) ||
          (cart.discount_codes || []).some(function (d) { return (d.code || '').toLowerCase() === code.toLowerCase() && d.applicable; });
        if (aplicado) {
          mostra('Cupom aplicado!', '#2e7d32');
          input.value = '';
          document.dispatchEvent(new CustomEvent('cartUpdated', { detail: cart }));
        } else {
          mostra('Cupom inválido ou não atende aos requisitos.', '#c62828');
        }
      })
      .catch(function () {
        libera();
        mostra('Erro ao aplicar cupom. Tente novamente.', '#c62828');
      });
  };

  CicatribemMinicartController.prototype.updateItemQuantity = function (linha, quantidade) {
    var self = this;
    var url = (window.routes && window.routes.cart_change_url) || (raiz() + 'cart/change.js');
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: linha, quantity: quantidade, sections: ['minicart'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections && data.sections.minicart) return self.aplicarMinicart(data.sections.minicart, data);
        window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  };

  CicatribemMinicartController.prototype.aplicarMinicart = function (html, cart) {
    var self = this;
    return cbMinicart.atualizar(html, cart).then(function () {
      self.isUpdating = false;
      self.cartDrawer.classList.remove('is-updating');
    });
  };

  CicatribemMinicartController.prototype.recarregar = function () {
    var self = this;
    return cbMinicart.recarregar().then(function () {
      self.isUpdating = false;
      if (self.cartDrawer) self.cartDrawer.classList.remove('is-updating');
    });
  };

  new CicatribemMinicartController();
})();

/* 01/11/2026 (revisão de código, A3-2 / A4-1): "Compre também" do carrinho lateral. O drawer renderiza
   <minicart-recommendations-page data-url=…> (recomendações automáticas), mas o único JS que registrava esse elemento
   era o cart.js, carregado só na página /cart, onde o drawer não existe. Aqui vai uma versão mínima: busca o
   data-url (seção cart-upsell), copia os slides e mostra o bloco só quando há produto. Os botões "+ Adicionar" dos
   slides são formulários comuns, tratados pelo ouvinte de submit do global.js. Na página /cart o cart.js define
   primeiro (ordem do documento) e esta versão não é registrada. */
(function () {
  if (window.customElements && !customElements.get('minicart-recommendations-page')) {
    class CbRecomendacoesDrawer extends HTMLElement {
      connectedCallback() {
        if (this.__cbFeito) return;
        this.__cbFeito = true;
        var url = this.dataset.url;
        var alvo = this.querySelector('.swiper-wrapper');
        var self = this;
        self.style.display = 'none';
        if (!url || !alvo) return;
        fetch(url)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (t) {
            if (!t) return;
            var d = document.createElement('div');
            d.innerHTML = t;
            var rec = d.querySelector('.swiper-wrapper');
            if (!rec || !rec.innerHTML.trim()) return;
            alvo.innerHTML = rec.innerHTML;
            self.style.display = '';
            var trilho = self.querySelector('slide-section');
            var sw = trilho && (trilho.globalSlide || trilho.swiper);
            if (sw && typeof sw.update === 'function') sw.update();
            if (window.BlsLazyloadImg && typeof BlsLazyloadImg.init === 'function') BlsLazyloadImg.init();
          })
          .catch(function () {});
      }
    }
    customElements.define('minicart-recommendations-page', CbRecomendacoesDrawer);
  }
})();
